import {
  MOVE_INVENTORY,
  MOVE_INVENTORY_SUCCESS,
  MOVE_INVENTORY_FAILURE,
  LOAD_INVENTORY,
  LOAD_INVENTORY_SUCCESS,
  LOAD_INVENTORY_FAILURE,
  ADD_INVENTORY_ITEM,
  ADD_INVENTORY_ITEM_SUCCESS,
  ADD_INVENTORY_ITEM_FAILURE,
  ADD_FLYER_CODES,
  ADD_FLYER_CODES_SUCCESS,
  ADD_FLYER_CODES_FAILURE,
  DELETE_FLYER_CODE,
  DELETE_FLYER_CODE_SUCCESS,
  DELETE_FLYER_CODE_FAILURE,
  GET_INVENTORY_ITEM,
  GET_INVENTORY_ITEM_SUCCESS,
  GET_INVENTORY_ITEM_FAILURE,
} from './const'
import createMiddleware from 'Reducers/createMiddleware'
import {
  processInventoryMovements,
  getInventory,
  addInventoryItem,
  getInventoryItem,
  addFlyerCodes,
  deleteFlyerCodeById,
} from 'Module/graphQL'
//import idb from 'idb'

export const moveInventoryMiddleware = createMiddleware({
  actions: [MOVE_INVENTORY, MOVE_INVENTORY_SUCCESS, MOVE_INVENTORY_FAILURE],
  fetchMethod: (authToken, { inventoryMovement }) =>
    processInventoryMovements(authToken, [
      {
        cityId: inventoryMovement.cityId,
        quantity: inventoryMovement.quantity,
        inventoryId: inventoryMovement.inventoryId,
        ambassadorId: inventoryMovement.ambassadorId,
        comments: inventoryMovement.comments,
        movement: inventoryMovement.movement,
        dateTime: inventoryMovement.dateTime,
      },
    ]),
  isOptimistic: true,
})

export const loadInventoryMiddleware = createMiddleware({
  actions: [LOAD_INVENTORY, LOAD_INVENTORY_SUCCESS, LOAD_INVENTORY_FAILURE],
  fetchMethod: (authToken, payload) =>
    getInventory(authToken, payload.first, payload.after, {
      cityId: payload.filters.cityId,
      searchText: payload.filters.searchText,
      clientId: payload.filters.clientId,
      typeId: payload.filters.typeId,
      ambassadorId: payload.filters.ambassadorId,
      campaignId: payload.filters.campaignId,
      current: payload.filters.current,
      active: payload.filters.active,
      includeLeftovers: payload.filters.includeLeftovers,
    }),
  isOptimistic: true,
})

export const addInventoryItemMiddleware = createMiddleware({
  actions: [
    ADD_INVENTORY_ITEM,
    ADD_INVENTORY_ITEM_SUCCESS,
    ADD_INVENTORY_ITEM_FAILURE,
  ],
  fetchMethod: (authToken, { item }) => addInventoryItem(authToken, item),
  isOptimistic: true,
})

export const addFlyerCodesMiddleware = createMiddleware({
  actions: [ADD_FLYER_CODES, ADD_FLYER_CODES_SUCCESS, ADD_FLYER_CODES_FAILURE],
  fetchMethod: (authToken, { items }) => addFlyerCodes(authToken, items),
  isOptimistic: true,
})

export const deleteFlyerCodeMiddleware = createMiddleware({
  actions: [
    DELETE_FLYER_CODE,
    DELETE_FLYER_CODE_SUCCESS,
    DELETE_FLYER_CODE_FAILURE,
  ],
  fetchMethod: (authToken, { id }) => deleteFlyerCodeById(authToken, id),
  isOptimistic: true,
})

/**
 * Get an inventory item middleware
 */
export const getInventoryItemMiddleware = createMiddleware({
  actions: [
    GET_INVENTORY_ITEM,
    GET_INVENTORY_ITEM_SUCCESS,
    GET_INVENTORY_ITEM_FAILURE,
  ],
  fetchMethod: (authToken, payload) => getInventoryItem(authToken, payload.id),
  //isOptimistic: true,
})



// WEBPACK FOOTER //
// ./src/Reducers/Inventory/middleware.js